module.exports = __webpack_public_path__ + "static/media/not_equal.d8a64851.svg";